let ringtoneAudio = null;

export const playRingtone = () => {
  if (!ringtoneAudio) {
    ringtoneAudio = new Audio("/call_notification.mp3");
    ringtoneAudio.loop = true;
    ringtoneAudio.play().catch((err) => {
      console.warn("🔇 Ringtone autoplay blocked", err);
    });
  }
};

export const stopRingtone = () => {
  if (ringtoneAudio) {
    console.log("🔕 Stopping ringtone");
    ringtoneAudio.pause();
    ringtoneAudio.currentTime = 0;
    ringtoneAudio = null;
  }
};
